import React from "react";
export const DefaultRender = () => {
  return <></>;
};
